import { MAX_NUM_OF_PAYMENT_ATTEMPTS } from '_constants/payment';
import { STORAGE_KEYS } from '_constants/storage';
import {
  restoreLocalValue,
  restoreSessionValue,
  storeSessionValue,
} from '_helpers/storage';
import * as bcrypt from '_helpers/bcrypt';

export const createPaymentBody = (form, processingOption) => {
  const paymentBody = {
    processingOption,
    firstName: form.firstName,
    lastName: form.lastName,
    cardNumber: form.cardNumber.replace(/\s/g, ''),
    expMonth: form.cardMonth,
    expYear: '20' + form.cardYear,
    cvv: form.cvc,
    billingAddress: {
      address1: form.billingAddressAddress1,
      city: form.billingAddressCity,
      state: form.billingAddressState,
      zip: form.billingAddressZip,
      country: form.billingAddressCountry,
    },
  };

  if (form?.campaignId) {
    paymentBody.campaignId = form?.campaignId;
  }

  return paymentBody;
};

export const fillPaymentBodyWithSourceData = (paymentBody) => {
  if (restoreLocalValue(STORAGE_KEYS.source)) {
    paymentBody.affId = restoreLocalValue(STORAGE_KEYS.source);
  }

  if (restoreLocalValue(STORAGE_KEYS.adAccount)) {
    paymentBody.sourceValue1 = restoreLocalValue(STORAGE_KEYS.adAccount);
  }

  if (restoreLocalValue(STORAGE_KEYS.keyword)) {
    paymentBody.sourceValue2 = restoreLocalValue(STORAGE_KEYS.keyword);
  }
};

export const checkIfNumberOfPaymentAttemptsExceeded = () => {
  const billingCounter = restoreSessionValue(STORAGE_KEYS.billingCounter);
  return billingCounter >= MAX_NUM_OF_PAYMENT_ATTEMPTS;
};

export const checkIfCardDataNotChanged = async (cardData) => {
  const billingHash = restoreSessionValue(STORAGE_KEYS.billingHash);

  if (!billingHash) {
    return false;
  }

  const cardDataString = JSON.stringify(cardData);
  return await bcrypt.compare(cardDataString, billingHash);
};

export const increaseBillingCounter = () => {
  const billingCounter = restoreSessionValue(STORAGE_KEYS.billingCounter) || 0;
  storeSessionValue(STORAGE_KEYS.billingCounter, billingCounter + 1);
};

export const createBillingHash = async (cardData) => {
  const cardDataString = JSON.stringify(cardData);
  const billingHash = await bcrypt.createHash(cardDataString);
  storeSessionValue(STORAGE_KEYS.billingHash, billingHash);
};

export const createOrderSummary = (
  products = [],
  productNameMap = {},
  priceMap = {},
  feeMap = {}
) => {
  return products.reduce(
    (res, code) => {
      const name = productNameMap[code];
      const price = priceMap[code] || feeMap[code] || 0;

      res.products.push({ key: code, name, price });
      res.total = res.total + price;

      return res;
    },
    { products: [], total: 0 }
  );
};
